import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { RocketlaneUIControl, AsyncCreatableSelect as BaseAsyncCreatableSelect } from 'components/atoms/select';
import { CreatableSelect as BaseCreatableSelect } from 'components/atoms/select/creatable';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { createNewDesignStyles, NEW_DESIGN_STYLES } from './select';
const RocketUICreatableSelect = /*#__PURE__*/ forwardRef(({ components = {}, styles, ...props }, ref)=>{
    const computedStyles = createNewDesignStyles(NEW_DESIGN_STYLES, styles || {});
    return /*#__PURE__*/ _jsx(BaseCreatableSelect, {
        ...props,
        components: {
            Control: RocketlaneUIControl,
            ...components
        },
        styles: computedStyles,
        ref: ref
    });
});
const RocketUIAsyncCreatableSelect = /*#__PURE__*/ forwardRef(({ components = {}, styles, ...props }, ref)=>{
    const computedStyles = createNewDesignStyles(NEW_DESIGN_STYLES, styles || {});
    return /*#__PURE__*/ _jsx(BaseAsyncCreatableSelect, {
        ...props,
        components: {
            Control: RocketlaneUIControl,
            ...components
        },
        styles: computedStyles,
        ref: ref
    });
});
export const CreatableSelect = /*#__PURE__*/ forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    if (isNewDesignEnabled) {
        return /*#__PURE__*/ _jsx(RocketUICreatableSelect, {
            ...props,
            ref: ref
        });
    }
    return /*#__PURE__*/ _jsx(BaseCreatableSelect, {
        ...props,
        ref: ref
    });
});
export const AsyncCreatableSelect = /*#__PURE__*/ forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    if (isNewDesignEnabled) {
        return /*#__PURE__*/ _jsx(RocketUIAsyncCreatableSelect, {
            ...props,
            ref: ref
        });
    }
    return /*#__PURE__*/ _jsx(BaseAsyncCreatableSelect, {
        ...props,
        ref: ref
    });
});
CreatableSelect.displayName = 'CreatableSelect';
